<template>
    <v-row>
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>         
        <v-col v-else id="base" md="12" class="pb-0 mb-0" >
                        
            <v-row justify="start" style="font-size: 23px" class="RestoRegular pl-4">
                Mis métodos de pago
            </v-row>
            <v-row justify="center" class="pr-2 mt-4">
                <v-btn @click="goTo" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Agregar nuevo método de pago
                </v-btn>
            </v-row>
            <v-row justify="center" align="start" style="width: 95%; margin: 0 auto">
                <!-- <v-snackbar v-model="alert" class="font" :top="true" color="warning">
                    Ocurrió un problema
                </v-snackbar> -->
                <v-col>
                    <v-row v-for="(payment, index) in payments" :key="index" style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                       <v-col align-self="center" style="font-size: 12px;" class="RestoRegular ml-4" cols="3">
                            <v-row class="RestoBold" style="font-size: 13px;">
                                {{payment.alias}}
                            </v-row>
                        </v-col>
                        <v-col align-self="center" style="font-size: 12px;" class="RestoRegular ml-2">
                            <v-row >
                                ******** {{payment.digitos_final}}
                            </v-row>
                            
                        </v-col>
                        <v-col align-self="center" cols="auto">
                            <a @click="deleteItem(payment)" style="font-size: 14px; background-color: transparent; color: red" class="RestoBold">
                                Eliminar
                            </a>
                        </v-col>
                    </v-row>

                    <!-- <v-row style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                       <v-col align-self="center" style="font-size: 12px;" class="RestoRegular ml-4" cols="3">
                            <v-row class="RestoBold" style="font-size: 13px;">
                                Pago  entrega
                            </v-row>
                        </v-col>
                        <v-col align-self="center" style="font-size: 12px;" class="RestoRegular">
                            <v-row >
                                
                            </v-row>
                            
                        </v-col>
                        <v-col align-self="center">
                            
                        </v-col>
                        <v-col align-self="center" cols="auto"  class="my-0 py-0">
                            <v-radio-group v-model="active" class="my.0 py-0">
                                <v-radio :color="$store.state.colors.primary"  value="efectivo" class="my-0 py-0">
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row> -->

                </v-col>
            </v-row>
        </v-col>
        <v-dialog
                v-model="dialog"
                max-width="290"
            >
                <v-card>
                    <v-card-title class="headline"><span>¿Deseas eliminar la <br> tarjeta?</span></v-card-title>

                    <v-card-text>
                    Se eliminará la tarjeta ¿Deseas continuar?
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn @click="dialog=false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                        No
                    </v-btn>

                    <v-btn @click="deletePayment();dialog=false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                        Sí
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>    
        <!-- <v-dialog v-model="dialog" max-width="310">
            <v-card>
                <v-col>
                    <v-row justify="center" style="font-size: 25px; text-align: center; line-height: 29px; width: 80%; margin: 0 auto">
                        Esto hará que tu pedido se pierda
                    </v-row>
                    <v-row justify="center" class="RestoBold mt-2 mb-4" style="font-size: 18px; text-align: center; line-height: 18px; width: 80%; margin: 0 auto">
                        ¿Deseas continuar?
                    </v-row>
                </v-col>
                
                <v-card-title style="font-size: 32px"><span>Esto hará que tu pedido se pierda</span></v-card-title>
                <v-card-text style="font-size: 28px">
                ¿Estás de acuerdo?
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="dialog = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="goTo(); dialog = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
    </v-row>
</template>


<script>
import axios from 'axios'
export default {
    data() {
        return {
            // dialog: false,
            payments: null,
            active: "Banamex",
            validateLoad:true,
            dialog: false,
            editedIndex: null,
            alert: false,
        }
    },
    created() {
        // console.log(localStorage.getItem("id_cliente"));
        this.$store.dispatch("GET", {url: '/datos_b_c/' + localStorage.getItem("id_cliente") + '/' + localStorage.getItem("id_sucursal") , headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                // console.log(response);
                this.payments = response.data.tarjetas;
                localStorage.setItem('userCards', JSON.stringify(response.data));
                // localStorage.set('userCards', )
                this.$store.state.userCards = response.data;
                // console.log(this.$store.state.userCards);
                for(var i=0;i<this.payments.length;i++)
                {
                    if(this.payments[i].digitos_inicial==null)
                    {
                        this.payments[i].digitos_inicial='XXXXXX'
                    }
                    if(this.payments[i].digitos_final==null)
                    {
                        this.payments[i].digitos_final='XXXX'
                    }
                }
                this.validateLoad=false;
            })
            .catch(error => {
                console.log("Error: " + error);
            });
    },
    methods: {
        deleteItem (item) {
            if(this.payments.length > 1)
            {
                console.log(item);
                this.editedIndex = this.payments.indexOf(item);
                console.log(this.editedIndex);
                this.dialog = true;
            }
        },
        deletePayment()
        {
          var obj={
              id_cliente: localStorage.getItem('id_cliente'),
              id_sucursal: localStorage.getItem('id_sucursal'),
              id_tarjeta: this.payments[this.editedIndex].id_tarjeta,
              id: this.payments[this.editedIndex].id,
          };
          console.log(obj);
           axios.post("/baja_tarjeta",obj, {headers: {Authorization: this.$store.state.token}} )
            .then(res => {
              console.log("Respuesta: ", res);
              if(res.data.mensaje=='Tarjeta desactivada')
              {
                  this.payments.splice(this.editedIndex,1)
                  localStorage.setItem('userCards', JSON.stringify(this.payments));
              }
              else{
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "Ocurrió un problema";
                this.$store.state.alertColor = "error";
                setTimeout(() => {
                    this.$store.state.alertState = false;
                }, 4000);   
              }
            })
            .catch(error => {
              console.log(error);
            });
        // this.$store.dispatch("POST", {url: '/baja_tarjeta', body: obj, headers: {'x-auth-token': localStorage.getItem("token")}})
        //         .then(response => {
        //             console.log(response);
        //         })// eslint-disable-next-line
        //         .catch(error => {
        //             // eslint-disable-next-line
        //             console.log("Error: " + error);
        //         });        
        },
        goTo(){
            this.$router.push({name: 'newPaymentMethod'});
            this.$nextTick(() => {
                location.reload();
            });
        },
        maskCard(card){
            var res = card.replace(/-/g, '');
            return res.length==16 ? res.substr(res.length - 4) : res.substr(res.length - 3);
        }
    }
}
</script>

<style scoped>
.a:hover 
{ 
  background-color:  #E6E6E6;
} 
</style>